<template>
  <div class="container-panelHeader">
    <span>wangho</span><span class="logo-text">智筑</span>
  </div>
</template>

<script>
export default {
  name: "PanelHeader",
};
</script>

<style scoped>
.container-panelHeader {
  box-sizing: border-box;
  height: var(--header-height);
  background-color: var(--primary-color);
  color: var(--font-color);
  font-weight: bold;
  font-style: italic;
  font-size: 24px;
  padding: 15px 5px 0px 0px;
}

.logo-text {
  font-size: 20px;
}

/* 手机屏幕样式 ***************************/
@media (orientation: portrait) and (max-width: 768px) {
  .container-panelHeader {
    font-size: 8px !important;
    padding: 19px 4px 0px 2px;
  }

  .logo-text {
    font-size: 10px;
  }
}
</style>
